import { buildQuery, containsQuery } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/documents";

const index = () => request(`${resource}/getList`, { method: "GET" });

const list = (params: {}) => {
    const query = containsQuery(params);
    return request(`${resource}/getList${query}`, { method: "GET" });
};

const checkDocuments = () => {
    const query = buildQuery({ top: 1 });
    return request(`${resource}/getList${query}`, { method: "GET" }).then((data) => data && data.length > 0);
};

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

export { index, apply, delItem, checkDocuments, list };
